//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { xzcf_list, xzxk_list, sxjl_list, sxcj_list, zdsswf, aqsc, tqnmggz, compDetail, XYPFDetail } from '@/api/publicCredit';
export default {
  data: function data() {
    return {
      nowIndex: 0,
      now: 0,
      keyword: '',
      XzxkList: [],
      //行政许可
      XzcfList: [],
      //行政处罚
      SxjlList: [],
      //守信激励
      SxcjList: [],
      //失信惩戒
      Zdsswf: [],
      //重大税收违法
      Aqsc: [],
      //安全生产失信
      Qnmggz: [],
      //严重拖欠工资
      compLists: [],
      //公司详情
      // XYPFDetailList: [],//信用评分
      Xzxktxt: 0,
      Xzcftxt: 0,
      Sxjltxt: 0,
      Sxcjtxt: 0,
      Zdsswftxt: 0,
      Aqsctxt: 0,
      Qnmggztxt: 0,
      XYPFText: 0,
      Xzxktxtimg: 1,
      xzcfimg: 1,
      sxjlimg: 1,
      sxcjimg: 1,
      zdsswfimg: 1,
      aqscsximg: 1,
      yztqgzimg: 1
    };
  },
  created: function created() {
    this.keyword = this.$route.query.keyword; // this.getCompDetail()

    this.getXzxkList();
    this.getXzcfList();
    this.getSxjlList();
    this.getSxcjList();
    this.getZdsswf();
    this.getAqsc();
    this.gettQnmggz();
  },
  methods: {
    toggleTabs: function toggleTabs(index) {
      this.now = index;
      this.nowIndex = index;

      if (this.nowIndex === 0) {
        this.getXzxkList();
      } else if (this.nowIndex === 1) {
        this.getXzcfList();
      } else if (this.nowIndex === 2) {
        this.getSxjlList();
      } else if (this.nowIndex === 3) {
        this.getSxcjList();
      } else if (this.nowIndex === 4) {
        this.getZdsswf();
      } else if (this.nowIndex === 5) {
        this.getAqsc();
      } else if (this.nowIndex === 6) {
        this.gettQnmggz();
      } // else if (this.nowIndex === 7) {
      //   this.getXYPFDetail()
      // }

    },
    //公司详情
    // async getCompDetail () {
    //   let param = { companyId: this.keyword }
    //   const res = await compDetail(this.sendParam(param));
    //   let result = this.paramDecrypt(res)
    //   if (result.code == 200) {
    //     this.compLists = result.data
    //   }
    // },
    //行政许可
    getXzxkList: function getXzxkList() {
      var _this = this;

      var data = {
        page: 1,
        pageSize: 10,
        keyword: this.keyword
      };
      var res = xzxk_list(this.sendParam(data));
      Promise.resolve(res).then(function (value) {
        //处理返回的Promise
        var result = _this.paramDecrypt(value);

        if (result.code == 200 && res.data !== null) {
          _this.XzxkList = result.data.list;
          _this.Xzxktxt = result.data.total;

          if (result.data.total == 0) {
            _this.Xzxktxtimg = 0;
          }
        } else {
          _this.$message.error(result.msg);
        }
      });
    },
    //行政处罚
    getXzcfList: function getXzcfList() {
      var _this2 = this;

      var data = {
        page: 1,
        pageSize: 10,
        keyword: this.keyword
      };
      var res = xzcf_list(this.sendParam(data));
      Promise.resolve(res).then(function (value) {
        //处理返回的Promise
        var result = _this2.paramDecrypt(value);

        if (result.code == 200 && res.data !== null) {
          _this2.XzcfList = result.data.list;
          _this2.Xzcftxt = result.data.total;

          if (result.data.total == 0) {
            _this2.xzcfimg = 0;
          }
        } else {
          _this2.$message.error(result.msg);
        }
      });
    },
    //守信激励
    getSxjlList: function getSxjlList() {
      var _this3 = this;

      var data = {
        page: 1,
        pageSize: 10,
        keyword: this.keyword
      };
      var res = sxjl_list(this.sendParam(data));
      Promise.resolve(res).then(function (value) {
        //处理返回的Promise
        var result = _this3.paramDecrypt(value);

        if (result.code == 200 && res.data !== null) {
          _this3.SxjlList = result.data.list;
          _this3.Sxjltxt = result.data.total;

          if (result.data.total == 0) {
            _this3.sxjlimg = 0;
          }
        } else {
          _this3.$message.error(result.msg);
        }
      });
    },
    //失信惩戒
    getSxcjList: function getSxcjList() {
      var _this4 = this;

      var data = {
        page: 1,
        pageSize: 10,
        keyword: this.keyword
      };
      var res = sxcj_list(this.sendParam(data));
      Promise.resolve(res).then(function (value) {
        //处理返回的Promise
        var result = _this4.paramDecrypt(value);

        if (result.code == 200 && res.data !== null) {
          _this4.SxcjList = result.data.list;
          _this4.Sxcjtxt = result.data.total;

          if (result.data.total == 0) {
            _this4.sxcjimg = 0;
          }
        } else {
          _this4.$message.error(result.msg);
        }
      });
    },
    //重大税收违法
    getZdsswf: function getZdsswf() {
      var _this5 = this;

      var data = {
        page: 1,
        pageSize: 10,
        keyword: this.keyword
      };
      var res = zdsswf(this.sendParam(data));
      Promise.resolve(res).then(function (value) {
        //处理返回的Promise
        var result = _this5.paramDecrypt(value);

        if (result.code == 200 && res.data !== null) {
          _this5.Zdsswf = result.data.list;
          _this5.Zdsswftxt = result.data.total;

          if (result.data.total == 0) {
            _this5.zdsswfimg = 0;
          }
        } else {
          _this5.$message.error(result.msg);
        }
      });
    },
    //安全生产失信
    getAqsc: function getAqsc() {
      var _this6 = this;

      var data = {
        page: 1,
        pageSize: 10,
        keyword: this.keyword
      };
      var res = aqsc(this.sendParam(data));
      Promise.resolve(res).then(function (value) {
        //处理返回的Promise
        var result = _this6.paramDecrypt(value);

        if (result.code == 200 && res.data !== null) {
          _this6.Aqsc = result.data.list;
          _this6.Aqsctxt = result.data.total;

          if (result.data.total == 0) {
            _this6.aqscsximg = 0;
          }
        } else {
          _this6.$message.error(result.msg);
        }
      });
    },
    //严重拖欠工资
    gettQnmggz: function gettQnmggz() {
      var _this7 = this;

      var data = {
        page: 1,
        pageSize: 10,
        keyword: this.keyword
      };
      var res = tqnmggz(this.sendParam(data));
      Promise.resolve(res).then(function (value) {
        //处理返回的Promise
        var result = _this7.paramDecrypt(value);

        if (result.code == 200 && res.data !== null) {
          _this7.Qnmggz = result.data.list;
          _this7.Qnmggztxt = result.data.total;

          if (result.data.total == 0) {
            _this7.yztqgzimg = 0;
          }
        } else {
          _this7.$message.error(result.msg);
        }
      });
    },
    //信用评分
    getXYPFDetail: function getXYPFDetail() {
      var _this8 = this;

      var data = {
        companyId: this.keyword
      };
      var res = XYPFDetail(this.sendParam(data));
      Promise.resolve(res).then(function (value) {
        //处理返回的Promise
        var result = _this8.paramDecrypt(value);

        if (result.code == 200 && res.data !== null) {
          _this8.XYPFDetailList = result.data;

          if (result.data.totalScore) {
            _this8.XYPFText = 1;
          }
        } else {
          _this8.$message.error(result.msg);
        }
      });
    }
  }
};